<section class="content-section space-y-4 mx-auto">
  <header
    class="group flex justify-between items-center text-xs sm:text-base md:mb-8 animate-[fadeUp_.7s_ease-out]"
  >
    <h2
      class="font-semibold text-base sm:text-2xl transition-transform duration-500 group-hover:translate-x-1"
    >
      <span>
        {{ title() }}
      </span>
    </h2>
    <a
      [routerLink]="listLink()"
      class="group text-primary font-medium lg:text-base flex items-center gap-x-2 transition-all duration-300 ease-in-out hover:text-[#1e7999]"
    >
      <span
        class="transition-all duration-300 group-hover:tracking-wide group-hover:blur-[0.2px]"
      >
        {{ 'View All' | translate }}
      </span>
      <div class="relative overflow-hidden flex items-center justify-center">
        <sham-i-arrow-line-right
          class="transition-all duration-300 transform group-hover:translate-x-5 group-hover:opacity-0 rtl:rotate-180"
        />

        <sham-i-arrow-line-right
          class="absolute -translate-x-5 opacity-0 transition-all duration-300 transform group-hover:translate-x-0 group-hover:opacity-100 text-[#1e7999] rtl:rotate-180"
        />
      </div>
    </a>
  </header>

  <div>
    <ng-content />
  </div>
</section>
